module.exports = __webpack_public_path__ + "img/vue2-doublure_blanc.3d640ec6.png";